import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-diamonds',
  templateUrl: './diamonds.component.html',
  styleUrls: ['./diamonds.component.scss'],
  standalone: false,
})
export class DiamondsComponent {
  @Input() value: number;
}
